import script from "./referralFooter.vue?vue&type=script&setup=true&lang=js"
export * from "./referralFooter.vue?vue&type=script&setup=true&lang=js"

import "./referralFooter.vue?vue&type=style&index=0&id=1a395f46&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a395f46"]])

export default __exports__